// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetRedebitsListRequestModel from '../../model/get-redebits-list-request-model';
import GetRedebitsListRequestDTO from '../dto/get-redebits-list-request-dto';
import dtoSchema from '../schemas/get-redebits-list-request-schema';

export default abstract class GetRedebitsListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetRedebitsListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.from = data.from;
      this.to = data.to;
      this.uploadStatusId = data.uploadStatusId;
      this.paymentStatus = data.paymentStatus;
      this.uploadStatusExported = data.uploadStatusExported;
      this.paymentStatusExpored = data.paymentStatusExpored;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {date-time}
  */
  from?: string;
  /**
  * @type {date-time}
  */
  to?: string;
  /**
  * @type {int32}
  */
  uploadStatusId?: number;
  /**
  */
  paymentStatus?: string;
  /**
  */
  uploadStatusExported?: boolean;
  /**
  */
  paymentStatusExpored?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetRedebitsListRequestDTO>): GetRedebitsListRequestModel;
  static toModel(dto: DeepPartial<GetRedebitsListRequestDTO> | undefined | null): GetRedebitsListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetRedebitsListRequestDTO> | undefined | null): GetRedebitsListRequestModel | undefined {
    return dto ? new GetRedebitsListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetRedebitsListRequestModel> | GetRedebitsListRequestModel): GetRedebitsListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      from: unwrapped.from,
      to: unwrapped.to,
      uploadStatusId: unwrapped.uploadStatusId,
      paymentStatus: unwrapped.paymentStatus,
      uploadStatusExported: unwrapped.uploadStatusExported,
      paymentStatusExpored: unwrapped.paymentStatusExpored,
      searchCriteria: unwrapped.searchCriteria,
    } as GetRedebitsListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetRedebitsListRequestModel, can not map to GetRedebitsListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
